
export const packagingKeysMap = new Map([
    ['default', 'Default'],
    ['mount_1_module', '1 Module value'],
    ['mount_1_5_module', '1.5 module value'],
    ['dcl', 'DCL packaging'],
    ['mount_2_modules', '2 modules value'],
    ['shutter_box', 'Shutter box package for NLLV'],
    ['din_1_module', 'DIN 1 module'],
    ['din_2_modules', 'DIN 2 module'],
]);
